import { gql, useQuery } from '@apollo/client';
import { useAuth } from '../contexts/AuthContext';

const GET_GUEST_EVENT_PLAN_OPTIONS = gql`
  query GetGuestEventPlanOptions {
    authenticatedGuest {
      id
      eventPlans {
        id
        name
        groupSize
      }
    }
  }
`;
export const useGuestEventPlans = () => {
  const { guest } = useAuth();
  const { data, loading, error } = useQuery(GET_GUEST_EVENT_PLAN_OPTIONS, {
    skip: !guest,
  });
  return { eventPlans: data?.authenticatedGuest?.eventPlans, loading, error };
};
